import React from 'react';
import { CheckCircle2, ShieldCheck, Star } from 'lucide-react';
export function HeroContent() {
  return <div className="lg:col-span-7 flex flex-col justify-center" data-id="element-527">
      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-50 text-primary-700 font-medium text-xs mb-3 w-fit border border-primary-100" data-id="element-528">
        <span className="relative flex h-2 w-2" data-id="element-529">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-500 opacity-75" data-id="element-530"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-primary-600" data-id="element-531"></span>
        </span>
        Commercial Glass Estimates Available
      </div>

      {/* Reputation badge */}
      <div className="inline-flex flex-wrap items-center gap-x-3 gap-y-1 bg-white border border-neutral-200 rounded-full shadow-sm px-4 py-2 mb-4 w-fit" aria-label="5-star reputation: Trusted by Michigan businesses, builders and property managers since 2000" data-id="element-532">
        <span className="flex items-center gap-1 text-amber-500" aria-hidden="true" data-id="element-533">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-current" data-id="element-534" />)}
        </span>
        <span className="text-xs sm:text-sm font-semibold text-neutral-800 font-sans" data-id="element-535">
          Trusted by Michigan Businesses, Builders & Property Managers
        </span>
        <span className=".9-4.3 4.1 1 5hidden sm:inline text-neutral-300" data-id="element-536">
          ·
        </span>
        <span className="text-xs sm:text-sm text-neutral-600 font-sans" data-id="element-537">
          Commercial Glass Since 2000
        </span>
      </div>

      {/* Estimates availability badge */}
      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-50 text-primary-700 font-medium text-xs mb-3 w-fit border border-primary-100" data-id="element-538">
        <span className="relative flex h-2 w-2" data-id="element-539">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-500 opacity-75" data-id="element-540"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-primary-600" data-id="element-541"></span>
        </span>
        Commercial Glass Estimates Available
      </div>

      {/* Main heading */}
      <h1 className="kosins-heading text-3xl sm:text-4xl lg:text-5xl text-neutral-900 leading-[1.05] mb-4" data-id="element-542">
        <span className="text-primary-600" data-id="element-543">Commercial Glass Company</span> for
        Storefronts, Offices &{' '}
        <span className="text-primary-600" data-id="element-544">Contract Glazing in Michigan</span>
      </h1>

      {/* Feature list */}
      <ul className="space-y-2 mb-5 font-sans" data-id="element-545">
        {['Storefront glass repair, replacement, doors and commercial windows', 'Office glass walls, dividers, partitions and interior glass systems', 'Contract glazing for new construction, renovations and existing buildings', 'Accurate quotes, reliable installations'].map((bullet, idx) => <li key={idx} className="flex items-start gap-3 anim-slide-in-left-sm" style={{
        animationDelay: `${0.2 + idx * 0.1}s`
      }} data-id="element-546">
            <CheckCircle2 className="w-3.5 h-3.5 fill-current" data-id="element-547" />
            <span data-id="element-548">{bullet}</span>
          </li>)}
      </ul>

      {/* Security notice */}
      <div className="flex items-center gap-2 text-xs" style={{
      animationDelay: '0.6s'
    }} data-id="element-549">
        <ShieldCheck className="w-4 h-4 text-neutral-400" data-id="element-550" />
        <span data-id="element-551">
          Your information is secure. Kosin's Glass will never share your
          details.
        </span>
      </div>
    </div>;
}